import { ShowCustomDataAction } from '@app/modules/audit/components/ShowCustomDataAction';
import { getMentionVerifyMatchTargetFromSchedule } from '@app/modules/audit/modules/station-audit/components/verify-match/to-verify-match-target';
import { useVerifyMatchListDialog } from '@app/modules/audit/modules/station-audit/components/verify-match/useVerifyMatchListDialog';
import { VerifyMatchAction } from '@app/modules/audit/modules/station-audit/components/verify-match/VerifyMatchAction';
import { VerifyMatchListDialog } from '@app/modules/audit/modules/station-audit/components/verify-match/VerifyMatchListDialog';
import { MrtTable } from '@mi-front/ui';
import { defineMessage } from 'react-intl';
import { RowActions } from '../../../../../../../../components/table/RowActions';
import { ListingResultProps } from '../../../../../../../../core/reports/components/ListingView';
import { useReportCtx } from '../../../../../../../../core/reports/report-ctx';
import { ScheduleMatchStatus } from '../../../../components/schedule/ScheduleMatchStatus';
import { useSchedulesListColumns } from '../../useSchedulesListColumns';
import { SchedulesMentionsListing } from './SchedulesMentionsListView';

const mentionIdColumnHeaderMessage = defineMessage({
  id: 'audit.props.mentionId',
  defaultMessage: 'ID mention',
});

/**
 * Mentions schedules table with verify-match dialog navigation.
 */
export function SchedulesListMentionsResult(p: ListingResultProps<SchedulesMentionsListing>) {
  const { refreshReport } = useReportCtx<SchedulesMentionsListing>();
  const { openAt, onDisplayRowsChange, dialogProps } = useVerifyMatchListDialog(
    getMentionVerifyMatchTargetFromSchedule,
    refreshReport,
  );

  const columns = useSchedulesListColumns({
    customIdHeader: mentionIdColumnHeaderMessage,
    actionsColumnSize: 120,
    statusCell: ({ row }) => <ScheduleMatchStatus schedule={row.original} />,
    actionsCell: ({ row }) => {
      const verifyTarget = getMentionVerifyMatchTargetFromSchedule(row.original);

      return (
        <RowActions>
          {verifyTarget && <VerifyMatchAction onClick={() => openAt(verifyTarget)} />}
          <ShowCustomDataAction customId={row.original.customId} customData={row.original.custom} />
        </RowActions>
      );
    },
  });

  return (
    <>
      <MrtTable
        {...p.mrtProps}
        enableTopToolbar={false}
        onDisplayRowsChange={onDisplayRowsChange}
        columns={columns}
      />
      <VerifyMatchListDialog dialogProps={dialogProps} />
    </>
  );
}
